export const MOVIE_FETCH_SUCCESS= 'movies/fetchSuccess'
export const MOVIE_DETAIL_ID= 'movies/detailSuccess'
export const NEW_MOVIE= 'movies/createSuccess'
export const EDIT_MOVIE= 'movies/editSuccess'
export const DELETE_MOVIE= 'movies/deleteSuccess'

export const GENRE_FETCH_SUCCESS= "genres/fetchSuccess"
export const GENRE_DETAIL= "genres/detailGenre"
export const GENRE_EDIT= 'genres/editSuccess'
export const NEW_GENRE= 'genres/createSuccess'
export const DELETE_GENRE= 'genres/deleteSuccess'